import Button from 'antd/lib/button';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTER_REDIRECT } from '@/helpers/routeHelpers';
import RightArrowCircledIcon from '../icons/RightArrowCircledIcon';

const GoToReleaseCTA: React.FC<{ releasePath: string }> = ({ releasePath }) => {
    const history = useHistory();

    return (
        <Button
            type="link"
            style={{ fontWeight: 600, paddingRight: 0 }}
            onClick={() => {
                history.push(releasePath, {
                    [ROUTER_REDIRECT]: true,
                });
            }}
        >
            <div
                style={{
                    display: 'inline-flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 8,
                    height: '100%',
                }}
            >
                Go to release
                <RightArrowCircledIcon />
            </div>
        </Button>
    );
};

export default GoToReleaseCTA;
